import { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES } from '../../../constants/infrastructure';
import { IRegularInfrastructureType } from '../../../types/map';

export const useInfrastructureTypesState = (
  infrastructureTypes: IRegularInfrastructureType[] | null,
): [string[], Dispatch<SetStateAction<string[]>>] => {
  const [currentTypes, setCurrentTypes] = useState<string[]>(ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES);

  useEffect(() => {
    if (infrastructureTypes) {
      const firstInfrastructureType = infrastructureTypes[0].type;
      setCurrentTypes([...ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES, firstInfrastructureType]);
    } else {
      setCurrentTypes(ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES);
    }
  }, [infrastructureTypes]); // eslint-disable-line react-hooks/exhaustive-deps

  return [currentTypes, setCurrentTypes];
};
